// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.check-header {
  height: 320px;
  position: relative;
  width: 100%;
}
.check-border-not {
  width: 100%;
  border:1px solid #000;
  border-radius: 10px;
  height: 240px;
}

.check-date {
  position: absolute;
  text-align: right;
}

.check-amount {
  position: absolute;
  top: 100px;
  right: 0px;
  /*top: {{vm.print.checkStock.payment_amount_top}}px;
  right: {{vm.print.checkStock.payment_amount_right}}px;*/
}

.stub {
  width: 100%;
  white-space: nowrap;
  min-height: 320px;
}

.check-stub-table {
  font-size: 70%;
  width: 24%;
  float: left;
  margin-right: 5px;
  font-weight: normal;
}
.check-number {
  position: absolute;
  font-size: 120%;
}

.check-stub-table th {
  border-bottom: 2px solid #000;
  padding: 2px;
}

.check-stub-table td {
  border-bottom: 1px solid #000;
  padding: 1px;
}

.micr {
  position: absolute;
  width: 100%;
  text-align: center;
  padding-bottom: 42px;
  bottom: 0px;
  left: 0px;
}

.micr img {
  height: 13px;
}

.signature-line {
  position: absolute;
  bottom: 90px;
  right: 10px;
  white-space: nowrap;
}

.pay {
  position: absolute;
  top: 110px;
  left: 0px;
  white-space: nowrap;
  font-size: 90%;
}

.amount-text {
  position: absolute;
  white-space: nowrap;
  font-size: 90%;
}
.to-order {
  position: absolute;
  top: 140px;
  left: 0px;
}
.payee {
  position: absolute;
  top: 140px;
  left: 60px;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
